import { fonts } from '@/theme/fonts';
import styled from 'styled-components';

interface ToggleButtonProps {
  ison: boolean;
  onClickToggle: () => void;
  disabled?: boolean;
  unableChange?: boolean;
}
const ToggleButton = ({
  ison,
  onClickToggle,
  disabled = false,
  unableChange = false,
}: ToggleButtonProps) => {
  return (
    <ToggleWrapper
      data-ison={ison}
      onClick={onClickToggle}
      data-disabled={disabled}
      data-unable={unableChange}
    >
      <ToggleCircle data-ison={ison} data-unable={unableChange} />
      <ToggleLabel data-ison={ison} data-unable={unableChange}>
        {ison || unableChange ? 'On' : 'Off'}
      </ToggleLabel>
    </ToggleWrapper>
  );
};

export default ToggleButton;

const ToggleWrapper = styled.button`
  position: relative;
  width: 67px;
  height: 28.4px;
  border-radius: 50px;
  border: none;
  cursor: pointer;
  background: #ff3445;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0 8px;
  transition: all 0.3s ease;
  font-weight: 600;
  font-size: 14px;
  &[data-ison='true'] {
    background: #fafdff;
    justify-content: flex-end;
  }
  &[data-disabled='true'] {
    pointer-events: none;
    opacity: 0.5;
  }
  &[data-unable='true'] {
    background: #6b97f8;
  }
`;

const ToggleCircle = styled.div`
  width: 16.5px;
  height: 16.5px;
  border-radius: 50%;
  background: #ffffff;
  position: absolute;
  left: 4px;
  transition: left 0.3s ease;
  &[data-unable='true'] {
    border: none;
    left: calc(100% - 28px);
  }
  &[data-ison='true'][data-unable='false'] {
    left: calc(100% - 28px);
    background: #6b97f8;
  }
`;

const ToggleLabel = styled.span`
  position: absolute;
  width: 100%;
  text-align: center;
  font-size: 18px;
  font-weight: ${fonts.weight.regular};
  z-index: 1;
  left: 10px;
  color: white;
  &[data-ison='true'][data-unable='false'] {
    left: -11px;
    color: #6b97f8;
  }
  &[data-unable='true'] {
    left: -11px;
    color: white;
  }
`;
